import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Sponsors from '../components/Sponsors';
import HorizontalFormContact from '../components/HorizontalFormContact';
import '../assets/styles/containers/Home.sass';

const Home = () => {
  const [contentTop, setContentTop] = useState({content_es: null});
  const [sponsors, setSponsors] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/home`)
    .then(res => res.json())
    .then(
      (res) => {
        setContentTop(res.content_top);
        setSponsors(res.sponsors);
      },
      (error) => {
        console.error(error);
      }
    )
  }, []);

  return (
    <Layout
      title={contentTop.seo_title_es}
      description={contentTop.seo_content_es}
    >
      <Banner id={10} city="home" thumb="logo_colombia.png"/>
      <HorizontalFormContact />
      <div className="container Home">
        {ReactHtmlParser(contentTop.content_es)}
      </div>
      {sponsors &&
        <Sponsors
          items={sponsors}
        />
      }
    </Layout>
  );
}

export default Home;
